module.exports = __webpack_public_path__ + "img/11.cff44cdd.png";